import Solver from './solver'
import { inverse } from '../utils'
import { SolverNames } from '../constants'

export default class ColSolver extends Solver {
  getName () {
    return SolverNames.COL_SOLVER
  }

  runSolver () {
    const col = inverse(this.puzzle)[this.solvingSpot]
    return this.solveVals(col)
  }

  isSolving (x: number) {
    return x === this.solvingSpot
  }

  isComplete (solvingSpot: number) {
    const col = inverse(this.puzzle)[solvingSpot]
    return col.every((spot) => spot.length === 1)
  }

  shouldSolve (solvingSpot: number): boolean {
    return !this.noAutos.includes(solvingSpot)
  }
}
